export const otherRegex = /^\s*other/gi; // NOTE: just a rough regex to try and find teh text 'other' in a string

export const isOptionOther = (text: string, regex = otherRegex) => {
  return new RegExp(regex).test(text);
}